"use client";
import { FC } from "react";
import { ButtonJoin } from "@/components/common/Buttons";

type Props = {};

const FirstBlock: FC<Props> = () => {
	return (
		<div className='relative w-full h-[calc(100vh-74px)] max-tablet:h-[40vh] bg-black'>
			<video
				autoPlay
				loop
				muted
				playsInline
				className='absolute inset-0 object-fit w-full h-full z-0 max-tablet:mt-[-44px]'>
				<source src='/video/bgVid.webm' />
			</video>
			<div className='z-10 bg-firstScreenGradient w-full h-[500px] mb-[-3px] flex flex-col justify-end items-center pb-[27px] absolute bottom-0 left-0 right-0'>
				<h1 className='text-[46px] leading-[60px] text-white font-extrabold text-center max-desktop:text-[27px] max-desktop:leading-[34px] max-tablet:text-[20px] max-tablet:leading-[21px] tracking-[2px] max-tablet:tracking-[0px]'>
					The Ultimate Bridge Playing Experience
				</h1>
				<p className='text-[27px] text-center text-white mb-[20px] max-desktop:text-[16px] max-tablet:text-[11px] max-desktop:mb-[21px] tracking-[1px] max-tablet:tracking-[0px]'>
					Join our growing community, practice with PowerShark, and win big in
					our tournaments!
				</p>
				<div id='About'>
					<ButtonJoin title='Join Now!' anchor="#App"/>
				</div>
			</div>
		</div>
	);
};

export default FirstBlock;
